/* tslint:disable */
/* eslint-disable */
export enum WorkCalculationTemplateVariableRoundModeEnum {
  None = 'none',
  Up = 'up',
  Down = 'down',
  Nearest = 'nearest'
}
